import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { stages } from './homeData';
import ConfirmationModal from './home-modals/ConfirmationModal';
import PropTypes from 'prop-types';
import { donationInfoOption } from './homeData';

const Page5 = ({ setStage }) => {
  const [activeEdit, setActiveEdit] = useState(false);
  const [show, setShow] = useState(false);

  return (
    <>
      <Card className="we-card-shadow">
        <Card.Header className="p-4">
          <Card.Title className="mb-0 text-uppercase">
            Donation information
          </Card.Title>
        </Card.Header>
        <Card.Body className="p-4 pt-0">
          <hr className="mt-0" />

          <div className="mb-4 mt-4">
            {donationInfoOption?.map(donation => (
              <div
                key={donation.id}
                className="border rounded-3 p-3 mb-3 position-relative"
              >
                {activeEdit && (
                  <IconButton
                    variant="default"
                    className={`${
                      donation.editAble ? 'text-danger' : 'text-500'
                    } bg-100 donation-info-edit-icon`}
                    icon={'times-circle'}
                    onClick={() => {
                      donation.editAble && console.log(donation.id);
                    }}
                  />
                )}

                <Flex justifyContent="between" alignItems="center">
                  <p className="mb-2 fw-semi-bold text-800">
                    {donation.donationType}
                  </p>
                  <p className="mb-2 fw-semi-bold text-800">
                    {donation.donationAmount}
                  </p>
                </Flex>
                <Flex justifyContent="between" alignItems="center">
                  <p className="mb-0 text-600">{donation.charge}</p>
                  <p className="mb-0 text-600">{donation.chargeAmount}</p>
                </Flex>
              </div>
            ))}
          </div>

          <IconButton
            variant="falcon-default"
            className="w-100 mb-4 py-2 text-600 text-uppercase bg-soft-secondary shadow-none border"
            icon="pencil-alt"
            iconClassName="ms-2"
            iconAlign="right"
            onClick={() => setActiveEdit(pre => !pre)}
          >
            Edit your donation
          </IconButton>

          <Flex justifyContent="between" alignItems="center" className="mb-4">
            <p className="fs-0 fw-semi-bold mb-0 text-900">Total amount</p>
            <p className="fs-0 fw-semi-bold mb-0 text-900">1,050 USD</p>
          </Flex>

          <Button
            size="lg"
            className="w-100 h-52 text-uppercase"
            onClick={() => setShow(true)}
          >
            Pay Now
          </Button>
        </Card.Body>
      </Card>
      <ConfirmationModal
        show={show}
        setShow={setShow}
        title="Divide your contributions !"
        subTitle="would like to split your donation of $1000 to monthly donation of $100/M for 10 Months ?"
        noBtnText="No, Thank You"
        yesBtnText={
          <span>
            <FontAwesomeIcon icon={'hand-holding-heart'} className="me-2" />
            Yes, I would like to be monthly supporter
          </span>
        }
        noBtnAction={() => setStage(stages.Payment)}
        yesBtnAction={() => {
          console.log('yes');
          setStage(stages.Payment);
        }}
      />
    </>
  );
};

Page5.propTypes = {
  setStage: PropTypes.func.isRequired
};

export default Page5;
